import {OnboardingStyle} from "@components/onboarding/onboarding.style";
import {createStyles, Theme} from "@material-ui/core";

export const ScheduleCreateStyles = (theme: Theme) => createStyles({
    ...OnboardingStyle(theme),
});



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepScheduleCreate/scheduleCreate.styles.ts